export {
    default as SwiperElement,
    type SwiperElementProps,
} from './SwiperElement';
